<template>
  <section>
    <div class="topup-error" v-if="topupError">
      <h3>Podczas przetwarzania doładowania wystapił błąd!</h3>
      <p>Spróbuj ponownie lub skonsultuj się z pomocą techniczną.</p>
    </div>
    <form class="topup-form" @submit="submit">
      <div class="topup-form-frame">
        <div class="topup-loading" v-if="isLoading">Przetwarzanie danych...</div>
        <h2><strong>Krok 3</strong> - Podsumowanie i płatność</h2>
        <h1>Podsumowanie</h1>
        <div>
          <div class="topup-summary">
            <div class="topup-phones-list" v-for="(topup, topupIndex) in formData.topup" :key="topupIndex">
              <div>
                <p>
                  Numer telefonu<br>
                  <strong>{{topup.phone}}</strong>
                </p>
                <p>
                  Kwota<br>
                  <strong>{{topup.amount}} zł</strong>
                </p>
              </div>
              <div v-if="topupIndex === 0">
                <p>
                  Adres e-mail<br>
                  <strong>{{formData.email}}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="topup-agreements">
            <div class="with-checkbox">
              <input type="checkbox" id="checkAll" v-model="checkAll" />
              <label class="check-label" for="checkAll">
                <span class="check-label-box"></span>
                <span class="check-label-text"><strong>Zaznacz wszystkie zgody</strong></span>
              </label>
            </div>
            <div class="with-checkbox">
              <input type="checkbox" id="agreement" v-model="form.agreement" />
              <label class="check-label" for="agreement">
                <span class="check-label-box"></span>
                <span class="check-label-text"><span class="red">*</span> Zapoznałem się i akceptuję <a href="/files/wrodzinie/Regulamin-doladowan-wRodzinie.pdf" target="_blank" rel="noreferrer">Regulamin doładowań telefonów komórkowych</a> oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Politykę&nbsp;prywatności</a></span>
              </label>
            </div>
            <div class="with-checkbox">
              <input type="checkbox" id="payment" v-model="form.payment" />
              <label class="check-label" for="payment">
                <span class="check-label-box"></span>
                <span class="check-label-text"><span class="red">*</span> Chcę, aby usługa została zrealizowana niezwłocznie i przyjmuję do wiadomości, że w przypadku pełnego wykonania usługi, z chwilą jej wykonania, utracę prawo do odstąpienia od umowy.</span>
              </label>
            </div>
            <p><span class="red">*</span> pole wymagane</p>
          </div>
          <div class="rodo">
            Administratorem danych osobowych jest Autopay S.A. ul. Powstańców Warszawy 6, 81-718 Sopot. Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji płatności. Podstawa prawna, cel, okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a
            href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Polityce prywatności Autopay S.A.</a>
          </div>
        </div>
      </div>
      <div class="topup-form-buttons">
        <button id="go-back-step-3" type="button" @click="goBack" :disabled="isLoading">‹ Wróć</button>
        <button id="submit-step-3" type="submit" :disabled="!isFormValid() || isLoading">Zamawiam i płacę ›</button>
      </div>
    </form>
  </section>
</template>

<script>
import TopupStep3Mixin from '../../../common/mixins/Topup/Stage3.mixin'

export default {
  name: 'TopupStage3',
  mixins: [TopupStep3Mixin]
}
</script>

<style src="../../assets/scss/topup-main.scss" lang="scss"></style>
